import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { OccupationCodeJsonFile } from '../models/hrm-lookup.models';
import { BaseHrmLookupClient } from './base-hrm-lookup.client';

@Injectable({
  providedIn: 'root',
})
export class OccupationCodesClient extends BaseHrmLookupClient<OccupationCodeLookupItemModel> {
  protected override FILE_PATH = 'generated/occupation-codes.json';

  getOccupationCodes(): Observable<OccupationCodeLookupItemModel[]> {
    return this.getCachedOrFetch();
  }

  protected mapFileToModel(data: OccupationCodeJsonFile): OccupationCodeLookupItemModel[] {
    const result: OccupationCodeLookupItemModel[] = [];

    for (const [code, item] of Object.entries(data.occupationCodes)) {
      const mappedItem: OccupationCodeLookupItemModel = {
        code,
        name: item.n,
        displayName: `${code} - ${item.n}`,
      };

      if (item.f) {
        mappedItem.activeFrom = new Date(item.f);
      }
      if (item.t) {
        mappedItem.activeTo = new Date(item.t);
      }

      result.push(mappedItem);
    }

    return result;
  }
}

export type OccupationCodeLookupItemModel = {
  code: string;
  name: string;
  displayName: string;
  activeFrom?: Date;
  activeTo?: Date;
};
